import * as React from 'react'
// context
import TasksListAPI from 'containers/StrategyActions/components/TasksList/layers/API'
import TasksListBL from 'containers/StrategyActions/components/TasksList/layers/BL'
// components
import TasksList from 'components/PageComponents/Home/components/DashboardWidgets/components/StrategyActions/components/Content/components/TasksList'
// types
import { IPlan } from 'types/graphql'
import { ITask } from 'containers/StrategyActions/components/TasksList/layers/API'

// types
interface Props {
  plan: IPlan
  extraTasks?: ITask[]
}

const TasksListContainer: React.FC<Props> = ({ plan, extraTasks }) => {
  return (
    <TasksListAPI plan={plan} extraTasks={extraTasks}>
      <TasksListBL>
        <TasksList />
      </TasksListBL>
    </TasksListAPI>
  )
}

export default TasksListContainer
